/**
 * TextArea
 * 解决问题:
 *    1. Antd TextArea 不支持 maxLength 问题
 */

import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { Input } from 'antd';

const AntdTextarea = observer((props) => {
  const {
    className = '',
    style = {},
    maxLength = null,
    onInput = () => {},
    ...params
  } = props;

  const handleInput = (event) => {
    if(!maxLength){
      onInput(event);
      return;
    }

    const value = event.target.value;
    if(value.length > maxLength){
      // 模拟回调，简易，有问题再处理
      onInput({
        target : {
          value : value.slice(0, maxLength),
        },
      });
      return;
    }

    onInput(event);
  }

  return (
    <Input.TextArea
      className={`setting-input setting-textarea setting-textarea-no-resize ${className}`}
      style={{ resize: "none", ...style }}
      onInput={handleInput}
      {...params}
      />
  )
});
export default AntdTextarea;